export default __webpack_public_path__ + "static/media/ctt.d372bb05.svg";